/**
 * * Color Mode Switcher Script, ready to copy/paste into any project, working perfectly... I hope
 * Supports NORMAL, DARK, and HIGH CONTRAST modes.
 * Professional Pfusch Script by Tobi :^)
 * Thank me later...
 */

/* ===========================
   SECTION 1: CONFIGURATION
   =========================== */

/**
 * Contrast Fix Table:
 * Define problematic text-on-background color combos here,
 * along with the alternative background color to fix contrast.
 * Ask your designer to fill this out properly.
 */
const contrastFixTable = [
	{text: '#FFFFFF', bg: '#00B4EB', fixBg: '#00799F'},
	{text: '#000000', bg: '#00B4EB', fixBg: '#00B4EB'},
	{text: '#FFFFFF', bg: '#463CC8', fixBg: '#463CC8'},
	{text: '#000000', bg: '#463CC8', fixBg: '#A5A0E4'},
	{text: '#161922', bg: '#463CC8', fixBg: '#A5A0E4'},
	{text: '#FFFFFF', bg: '#64BE9B', fixBg: '#388467'},
	{text: '#000000', bg: '#64BE9B', fixBg: '#64BE9B'},
	{text: '#FFFFFF', bg: '#F0780F', fixBg: '#A8540A'},
	{text: '#000000', bg: '#F0780F', fixBg: '#F0780F'},
	{text: '#FFFFFF', bg: '#B4D7F0', fixBg: '#2478B4'},
	{text: '#000000', bg: '#B4D7F0', fixBg: '#B4D7F0'},
	{text: '#FFFFFF', bg: '#F5AFCD', fixBg: '#D71B6B'},
	{text: '#000000', bg: '#F5AFCD', fixBg: '#F5AFCD'},
	{text: '#FFFFFF', bg: '#F5E637', fixBg: '#746B06'},
	{text: '#000000', bg: '#F5E637', fixBg: '#F5E637'},
	{text: '#FFFFFF', bg: '#E6321E', fixBg: '#8E1D10'},
	{text: '#000000', bg: '#E6321E', fixBg: '#F0867A'},
];

/**
 * Map to remember original background colors when applying contrast fixes.
 */
const originalBackgrounds = new Map();


/* ===========================
   SECTION 2: MAIN MODE SWITCH FUNCTIONS
   =========================== */

/**
 * Initialize the color mode switcher:
 * - Applies the saved mode from cookies (if any).
 * - Sets up UI listeners for mode toggling.
 */
function contrastSwitch() {
	const savedStyle = getCookie("style");

	// Apply previously saved mode, or default to NORMAL
	if (savedStyle === "dark") {
		document.querySelectorAll('.selection').forEach(selection => {
			if (selection.getAttribute('data-type') === 'dark') {
				selection.classList.add('active');
			}
		});
		applyDarkMode();
	} else if (savedStyle === "contrast") {
		applyContrastMode();
		document.querySelectorAll('.selection').forEach(selection => {
			if (selection.getAttribute('data-type') === 'contrast') {
				selection.classList.add('active');
			}
		});
	} else {
		resetColors();
		document.querySelectorAll('.selection').forEach(selection => {
			if (selection.getAttribute('data-type') === 'normal') {
				selection.classList.add('active');
			}
		});
	}

	document.querySelectorAll('.colorSwitcher').forEach(switcher => {
		if (switcher) {

			document.querySelectorAll('.colorSwitch').forEach(switchBox => {

				document.addEventListener('click', e => {
					if (!switchBox.contains(e.target)) {
						switchBox.classList.remove('active');
						switcher.classList.remove('active');
					}
				});

				document.getElementById('js-open-searchbox').addEventListener('click', e => {
					switchBox.classList.remove('active');
					switcher.classList.remove('active');
				});

				switcher.addEventListener('click', e => {
					e.stopPropagation();
					switchBox.classList.toggle('active');
					if (switchBox.classList.contains('active')) {
						switcher.classList.add('active');
					} else {
						switcher.classList.remove('active');
					}
				});

				const searchInput = document.querySelector('#js-searchbox input');

				if (searchInput) {
					searchInput.addEventListener('click', e => {
						switchBox.classList.remove('active');
					});
				}

			});
		}
	});


	document.querySelectorAll('.selection').forEach(selection => {
		selection.addEventListener('click', () => {
			const type = selection.getAttribute('data-type');
			if (type === 'dark') {
				applyDarkMode();
				setCookie("style", "dark", 7);
				document.querySelectorAll('.selection').forEach(selection => {
					if (selection.getAttribute('data-type') === 'dark') {
						selection.classList.add('active');
					} else {
						selection.classList.remove('active');
					}
				});
			} else if (type === 'contrast' && getCookie("style") !== 'contrast') {
				applyContrastMode();
				setCookie("style", "contrast", 7);
				document.querySelectorAll('.selection').forEach(selection => {
					if (selection.getAttribute('data-type') === 'contrast') {
						selection.classList.add('active');
					} else {
						selection.classList.remove('active');
					}
				});
			} else if (type === 'normal') {
				resetColors();
				setCookie("style", "normal", 7);
				document.querySelectorAll('.selection').forEach(selection => {
					if (selection.getAttribute('data-type') === 'normal') {
						selection.classList.add('active');
					} else {
						selection.classList.remove('active');
					}
				});
			} else {
				return;
			}

			document.querySelectorAll('.colorSwitch').forEach(switchBox => {
				switchBox.classList.remove('active');
			});
		});
	});
}

/**
 * Reset to NORMAL mode:
 * - Clears any custom styles from dark or contrast modes.
 */
function resetColors() {
	document.documentElement.style.setProperty('--color-white', '#FFFFFF');
	document.documentElement.style.setProperty('--color-black', '#000000');
	document.documentElement.style.removeProperty('--color-body-dark');

	document.body.style.backgroundColor = '#FFFFFF';
	document.body.style.color = '#000000';
	document.body.classList.remove('body-darkmode');
	document.body.classList.remove('body-contrastmode');

	document.querySelectorAll('.selection').forEach(selection => {
		selection.classList.remove('darkmode');
	});

	resetContrastMode();
}

/**
 * Apply DARK mode:
 * - Sets dark background and light text colors.
 */
function applyDarkMode() {
	document.documentElement.style.setProperty('--color-white', '#000000');
	document.documentElement.style.setProperty('--color-black', '#FFFFFF');
	document.documentElement.style.setProperty('--color-body-dark', '#FFFFFF');

	document.body.style.backgroundColor = '#000000';
	document.body.style.color = '#FFFFFF';
	document.body.classList.add('body-darkmode');
	document.body.classList.remove('body-contrastmode');

	document.querySelectorAll('.selection').forEach(selection => {
		selection.classList.add('darkmode');
	});


	resetContrastMode();
}

/**
 * Apply CONTRAST mode:
 * This is where the fun begins.
 * - Starts from normal colors.
 * - Walks all elements and fixes backgrounds for problematic color combos.
 */
function applyContrastMode() {
	resetColors();

	document.body.style.backgroundColor = '#FFFFFF';
	document.body.style.color = '#000000';
	document.body.classList.add('body-contrastmode');
	document.body.classList.remove('body-darkmode');

	const normalizedFixTable = contrastFixTable.map(({text, bg, fixBg}) => ({
		text: normalizeColor(text),
		bg: normalizeColor(bg),
		fixBg,
	}));

	const getFix = (textColor, bgColor) =>
		normalizedFixTable.find(rule => rule.text === textColor && rule.bg === bgColor);

	// Handle normal DOM elements
	// The dynamic-base-color thing is only needed for hali
	setTimeout(() => {
		document.querySelectorAll('*').forEach(el => {
			if (!el.textContent.trim()) return;

			const fontColor = normalizeColor(getComputedStyle(el).color);
			const {element: bgElement, isDynamic, dynamicValue: bgColor} = findBackgroundElement(el);

			const fix = getFix(fontColor, bgColor);

			if (fix) {
				if (!originalBackgrounds.has(bgElement)) {
					if (isDynamic) {
						const currentVar = getComputedStyle(bgElement).getPropertyValue('--dynamic-base-color') || '';
						originalBackgrounds.set(bgElement, {type: 'variable', value: currentVar});
					} else {
						const currentStyle = bgElement.style.getPropertyValue('background-color') || '';
						originalBackgrounds.set(bgElement, {type: 'style', value: currentStyle});
					}
				}

				if (isDynamic) {
					bgElement.style.setProperty('--dynamic-base-color', fix.fixBg, 'important');
				} else {
					bgElement.style.setProperty('background-color', fix.fixBg, 'important');
				}
			}
		});
	}, 100);


	// Handle SVG paths (check fill color)
	//Only needed for hali
	document.querySelectorAll('svg path').forEach(path => {
		const fillColor = normalizeColor(getComputedStyle(path).fill);
		if (!fillColor || fillColor === 'none') return;

		const bgElement = path.parentElement;
		if (!bgElement) return;

		const bgColor = normalizeColor(getComputedStyle(bgElement).backgroundColor);

		const fix = getFix(fillColor, bgColor);
		if (fix) {
			if (!originalBackgrounds.has(bgElement)) {
				const currentStyle = bgElement.style.getPropertyValue('background-color') || '';
				originalBackgrounds.set(bgElement, {type: 'style', value: currentStyle});
			}
			bgElement.style.setProperty('background-color', fix.fixBg, 'important');
		}
	});
}


/**
 * Remove all contrast mode background overrides and restore originals.
 */
function resetContrastMode() {
	originalBackgrounds.forEach((original, el) => {
		if (original.type === 'variable') {
			el.style.setProperty('--dynamic-base-color', original.value);
		} else if (original.type === 'style') {
			el.style.backgroundColor = original.value;
		}
	});
	originalBackgrounds.clear();
}


/* ===========================
   SECTION 3: HELPER UTILITIES
   =========================== */

/**
 * Normalize color strings to a consistent format (rgb/hex) using canvas.
 * Allows comparison regardless of input color format.
 */
function normalizeColor(color) {
	const ctx = document.createElement('canvas').getContext('2d');
	ctx.fillStyle = color;
	return ctx.fillStyle.toLowerCase();
}

/**
 * Given an element, find nearest ancestor (including itself) with a non-transparent background.
 * Falls back to document.body if none found.
 * The dynamic-base-color thing is only needed for hali
 */
function findBackgroundElement(el) {
	while (el && el !== document.body) {
		const styles = getComputedStyle(el);
		const dynamicColor = styles.getPropertyValue('--dynamic-base-color');

		if (dynamicColor) {
			return {
				element: el,
				isDynamic: true,
				dynamicValue: normalizeColor(dynamicColor),
			};
		}

		const bg = styles.backgroundColor;
		if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') {
			return {
				element: el,
				isDynamic: false,
				dynamicValue: normalizeColor(bg),
			};
		}

		el = el.parentElement;
	}
	return {
		element: document.body,
		isDynamic: false,
		dynamicValue: normalizeColor(getComputedStyle(document.body).backgroundColor),
	};
}


/**
 * Set a cookie with given name, value, and expiration days.
 */
function setCookie(name, value, days) {
	const d = new Date();
	d.setTime(d.getTime() + days * 86400000);
	document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}

/**
 * Get the value of a cookie by name.
 */
function getCookie(name) {
	const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	return match ? match[2] : null;
}

export {contrastSwitch};
